import React from "react"
import type { Grouping } from "./utils"

export type { Grouping }

const TABS: { key: Grouping; label: string }[] = [
  { key: "series", label: "By Series" },
  { key: "by_vintage", label: "By Vintage" },
  { key: "by_asset_class", label: "By Asset Class" },
  { key: "by_stage", label: "By Stage" },
  { key: "by_sector", label: "By Sector Focus" },
  { key: "by_portfolio_company", label: "By Portfolio Company" },
]

interface GroupingTabsProps {
  active: Grouping
  onChange: (grouping: Grouping) => void
}

const GroupingTabs = ({ active, onChange }: GroupingTabsProps) => (
  <div className="b-snapshot-summary-grouping-tabs">
    {TABS.map(({ key, label }) => (
      <button
        key={key}
        className={`b-snapshot-summary-tab${active === key ? " active" : ""}`}
        onClick={() => onChange(key)}
        type="button"
      >
        {label}
      </button>
    ))}
  </div>
)

export default GroupingTabs
